import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { createHttpClient } from '@adapters/HttpClient';
import { apiClientWH } from '@shared/services/ApiClient';
import { useToast } from '@shared/hooks/use-toast';
import { EligibleStorageApiAdapter } from '../adapters/EligibleStorageApiAdapter';

export const useCreateStoragePreInvoice = () => {
  const { t } = useTranslation('eligibleStorageModule');
  const { toast } = useToast();
  const queryClient = useQueryClient();

  const httpClient = createHttpClient(apiClientWH);
  const adapter = new EligibleStorageApiAdapter(httpClient);

  return useMutation({
    mutationFn: (storageIds: number[]) =>
      adapter.createStoragePreInvoice(storageIds),
    onSuccess: (data) => {
      toast({
        title: t('toast.createPreInvoiceSuccess'),
        description: t('toast.createPreInvoiceSuccessDescription', {
          id: data.id,
        }),
        variant: 'default',
      });
      queryClient.invalidateQueries({ queryKey: ['eligible-storages'] });
    },
    onError: (error: any) => {
      const errorMessage = error?.response?.data?.message || error.message;
      toast({
        title: t('toast.createPreInvoiceError'),
        description: errorMessage,
        variant: 'destructive',
      });
    },
  });
};
